"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectAction = exports.rescanMultiSelectActionElements = exports.init = void 0;
var csrf_token_1 = require("../utils/csrf-token");
var multi_select_actions = new Map();
function init() {
    document.querySelectorAll('.multi-select-actions').forEach(function (element) {
        var _a;
        if (!(element instanceof HTMLElement))
            return;
        var group = (_a = element.dataset.group) !== null && _a !== void 0 ? _a : '';
        if (group === '')
            return;
        multi_select_actions.set(group, new MultiSelectAction(element, group));
    });
    document.addEventListener('lgm.finish-load-more', function (event) {
        if (!(event instanceof CustomEvent))
            return;
        console.log(event.detail);
        var type = event.detail.resource;
        var multi_select_action = multi_select_actions.get(type);
        if (!multi_select_action) {
            var element = document.querySelector(".multi-select-actions[data-type=\"".concat(type, "\"]"));
            if (!(element instanceof HTMLElement))
                return;
            multi_select_actions.set(type, new MultiSelectAction(element, type));
        }
        else {
            var element = document.querySelector(".multi-select-actions[data-type=\"".concat(type, "\"]"));
            if (!(element instanceof HTMLElement))
                return;
            multi_select_action.rescanDom(element);
        }
    });
}
exports.init = init;
function rescanMultiSelectActionElements() {
    multi_select_actions.forEach(function (action) {
        action.rescanDom();
    });
}
exports.rescanMultiSelectActionElements = rescanMultiSelectActionElements;
var MultiSelectAction = /** @class */ (function () {
    function MultiSelectAction(root, group) {
        var _this = this;
        this.root = root;
        this.group = group;
        this.checkboxes = [];
        this.selected = [];
        this.name_to_attachment_ids = new Map();
        this.onCheckboxChange = function (event) {
            var input = event.target;
            if (!(input instanceof HTMLInputElement))
                return;
            var name = input.name;
            if (name === 'all') {
                _this.setAll(input.checked);
            }
            else {
                if (input.checked) {
                    _this.selected.push(name);
                }
                else {
                    _this.selected = _this.selected.filter(function (value) { return value !== name; });
                }
            }
            if (_this.isActive()) {
                _this.showPopup();
            }
            else {
                _this.hidePopup();
            }
        };
        this.onArchive = function () {
            if (_this.selected.length === 0)
                return;
            var laboratory_result_ids = _this.selected.map(function (name) { return Number.parseInt(name); }).filter(isFinite);
            var url = '/' + [
                'laboratory-results',
                'archive',
            ].join('/');
            var response = fetch(url, {
                method: "POST",
                headers: Object.assign({
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }, (0, csrf_token_1.get_csrf_token_header)()),
                body: JSON.stringify({ ids: laboratory_result_ids }),
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if ('success' in response && response.success) {
                    _this.triggerEventForSelectedCheckboxes('lgm.laboratory-result.archived');
                    _this.selected = [];
                    _this.hidePopup();
                    var popup = window.popups.get('message-success');
                    popup.open();
                    return;
                }
                else {
                    var error = ('errors' in response && response.errors instanceof Array)
                        ? response.errors.join('; ')
                        : 'Server Error';
                    throw new Error('Request to Server was not successful: ' + error);
                }
            }).catch(function (error) {
                var popup = window.popups.get('message-fail');
                popup.open();
            });
        };
        this.onDownload = function () {
            if (_this.selected.length === 0)
                return;
            var attachment_ids = _this.selected
                .map(function (name) { var _a; return (_a = _this.name_to_attachment_ids.get(name)) !== null && _a !== void 0 ? _a : []; })
                .reduce(function (list, next) { return list.concat(next); }, new Array())
                .filter(function (id) { return isFinite(id); });
            _this.triggerEventForSelectedCheckboxes('lgm.attachment.opened');
            _this.selected = [];
            _this.hidePopup();
            var url = '/' + [
                'attachments',
                'batch',
            ].join('/') + "?" + attachment_ids.map(function (id) { return "ids[]=" + id; }).join('&');
            _this.download(url);
        };
        this.rescanDom();
    }
    MultiSelectAction.prototype.rescanDom = function (new_root) {
        var _this = this;
        if (new_root === void 0) { new_root = null; }
        this.root = new_root !== null && new_root !== void 0 ? new_root : this.root;
        var popup = this.root.querySelector(".multi-select-actions__expands");
        if (!(popup instanceof HTMLElement))
            throw new Error('Failed to find actions-popup for ' + this.group);
        this.popup = popup;
        var action_download = this.root.querySelector(".multi-select-actions__download");
        if ((action_download instanceof HTMLButtonElement)) {
            this.action_download = action_download;
            this.action_download.addEventListener('click', this.onDownload);
        }
        var action_archive = this.root.querySelector(".multi-select-actions__archive");
        if ((action_archive instanceof HTMLButtonElement)) {
            this.action_archive = action_archive;
            this.action_archive.addEventListener('click', this.onArchive);
        }
        this.checkboxes.forEach(function (checkbox) {
            checkbox.removeEventListener('change', _this.onCheckboxChange);
        });
        this.checkboxes = __spreadArray([], __read(document.querySelectorAll("input[data-type=".concat(this.group, "].multi-select-action-checkbox"))), false).filter(function (element) { return element instanceof HTMLInputElement; });
        console.log(this.checkboxes);
        this.checkboxes.forEach(function (checkbox) {
            var _a, _b;
            checkbox.addEventListener('change', _this.onCheckboxChange);
            var name = checkbox.name;
            var ids = (_b = (_a = checkbox.dataset.attachments) === null || _a === void 0 ? void 0 : _a.split(',').map(function (id) { return parseInt(id); }).filter(function (id) { return isFinite(id); })) !== null && _b !== void 0 ? _b : [];
            _this.name_to_attachment_ids.set(name, ids);
        });
    };
    /**
     * Send an event to all currently selected checkboxes
     * @param event_name
     */
    MultiSelectAction.prototype.triggerEventForSelectedCheckboxes = function (event_name) {
        var _this = this;
        this.checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
            if (_this.selected.indexOf(checkbox.name) === -1) {
                return;
            }
            checkbox.dispatchEvent(new CustomEvent(event_name, {
                detail: {
                    element: checkbox,
                },
                bubbles: true
            }));
        });
    };
    MultiSelectAction.prototype.download = function (url) {
        // window.open(url, '_blank');
        var a = document.createElement('a');
        a.href = url;
        var now = new Date();
        var date = [now.getFullYear(), now.getMonth(), now.getDate()].join('-');
        a.download = "batch-".concat(date, ".zip");
        a.style.display = 'none';
        document.body.append(a);
        a.click();
        a.remove();
    };
    MultiSelectAction.prototype.setAll = function (checked) {
        var _this = this;
        this.selected = [];
        this.checkboxes.forEach(function (checkbox) {
            checkbox.checked = checked;
            if (checked) {
                _this.selected.push(checkbox.name);
            }
        });
    };
    MultiSelectAction.prototype.showPopup = function () {
        this.popup.classList.remove('js-hide');
        this.popup.classList.add('js-show');
    };
    MultiSelectAction.prototype.hidePopup = function () {
        this.popup.classList.add('js-hide');
        this.popup.classList.remove('js-show');
    };
    MultiSelectAction.prototype.isActive = function () {
        return this.selected.length !== 0;
    };
    return MultiSelectAction;
}());
exports.MultiSelectAction = MultiSelectAction;
